import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { EndPointApi } from '@helpers/endpointapi';
import { lastValueFrom } from 'rxjs';
import { DutyEngineerSetting } from 'icreate/common/models/duty-engineer-settings';

@Injectable({
    providedIn: 'root',
})
export class DutyEngineerSettingService {
    private domain: string;
    private headers: any = new HttpHeaders({
        'Content-Type': 'application/json',
    });

    constructor(private http: HttpClient) {
        this.domain = EndPointApi.iApiDomain();
    }

    async getByVessel(vesselId: string): Promise<DutyEngineerSetting | null> {
        try {
            return await lastValueFrom(
                this.http.get<DutyEngineerSetting>(`${this.domain}/api/dutyEngineerSettings/vessel/${vesselId}`, {
                    headers: this.headers,
                })
            );
        } catch {
            return null;
        }
    }

    async create(data: DutyEngineerSetting): Promise<DutyEngineerSetting> {
        return await lastValueFrom(
            this.http.post<DutyEngineerSetting>(`${this.domain}/api/dutyEngineerSettings`, data, {
                headers: this.headers,
            })
        );
    }

    async update(id: string, data: DutyEngineerSetting): Promise<DutyEngineerSetting> {
        return await lastValueFrom(
            this.http.put<DutyEngineerSetting>(`${this.domain}/api/dutyEngineerSettings/${id}`, data, {
                headers: this.headers,
            })
        );
    }
}
